    const accordions = document.querySelectorAll(".pAcc-item");
    accordions.forEach(item => {
        const header = item.querySelector(".pAcc-header");
        const content = item.querySelector(".pAcc-content");
        header.addEventListener("click", () => {
            const isOpen = item.classList.contains("pAcc-active");
            accordions.forEach(acc => {
                acc.classList.remove("pAcc-active");
                acc.querySelector(".pAcc-content").style.maxHeight = "0";
            });
            if (!isOpen) {
                item.classList.add("pAcc-active");
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });